<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DM8xF5/tc-custom/9781504074834.jpg?1720108822749" alt="This image is the cover for the book Walking Wolf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Walking Wolf
      </h1>
      <p class="bookDescription body article font2">
        <b>The Bram Stoker Award–winning author of <i>Sunglesss After Dark </i>chronicles the life of a werewolf who becomes part of the human—and inhuman—history of the Old West.</b><br/><br/> More than 150 years old, Billy Skillet looks back on his life existing between Native Americans and white men on the frontiers of a growing America, always on the edges of reality and unreality.<br/><br/> Born of a werewolf father and human mother from the Old Country, Billy is the only member of his family who survives a vicious attack. Found alive in the rubble of their homestead by a Comanche, Billy is taken in by the tribe. From there, he finds that—as a skinwalker—he is revered by the Native Americans, though reviled by the white man.<br/><br/> Battling powerful instincts and his own moral code, Billy embarks on his life’s never-ending journey, first learning the ways of the settlers at the hands of a brutal and drunken reverend, then with a charismatic con man peddling elixirs in a traveling show. He survives a lynching, becomes the manservant of a vampire, and battles one of his own kind, a beast consumed by evil ambition. He sees the rise and fall of legends, the births of his own children, and the deaths of his loved ones. And never far behind, Billy’s nemesis: a bounty hunter known as Witchfinder Jones, who, even now, may still be out there, willing to go to the ends of the earth to destroy him . . .<br/><br/><i>Originally published in </i>Dead Man’s Hand<br/><br/><b>Praise for Nancy A. Collins</b><br/><br/> “Possibly the most original voice in the world of vampire fiction since Anne Rice published <i>Interview with a Vampire</i>.” —<i>Film Threat</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nancy A. Collins
      </h2>
      
      <p class="authorDescription body article">Nancy A. Collins has authored more than 20 novels and novellas and numerous short stories. She has also worked on several comic books, including a 2-year run on the Swamp Thing series. She is a recipient of the Bram Stoker Award and the British Fantasy Award, and has been nominated for the Eisner, John W. Campbell Memorial, and International Horror Guild Awards. Best known for her groundbreaking vampire series Sonja Blue, which heralded the rise of the popular urban fantasy genre, Collins is the author of the bestselling <I>Sunglasses After Dark</I>, the Southern Gothic collection <I>Knuckles and Tales</I>, and the Vamps series for young adults.&#160;Her most recent novel is <I>Left Hand Magic</I>, the second installment in the critically acclaimed Golgotham urban fantasy series. She currently resides in Norfolk, Virginia, with a Boston terrier.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?403be2b8